export default __webpack_public_path__ + "static/media/Javanote.1db207e7.pdf";